'use client';

import Popover from '@mui/material/Popover';
import { Box, Link, Typography } from '@/primitives';
import type { TraitExplanationEntry } from './ebvTraitExplanations';

export type EbvTraitExplanationPopoverProps = {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  entry: TraitExplanationEntry | null;
  showBreedplanHelp?: boolean;
};

export default function EbvTraitExplanationPopover({
  open,
  anchorEl,
  onClose,
  entry,
  showBreedplanHelp = true,
}: EbvTraitExplanationPopoverProps) {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      slotProps={{
        paper: {
          sx: { maxWidth: 360, p: 2, borderRadius: 2 },
        },
      }}
    >
      {entry && (
        <Box>
          <Typography
            variant="bodysmall"
            sx={{ fontWeight: 600, color: 'text.primary', mb: 1 }}
          >
            {entry.title}
          </Typography>
          <Typography
            variant="bodysmall"
            sx={{ color: 'text.secondary', whiteSpace: 'pre-wrap' }}
          >
            {entry.description}
          </Typography>
          {showBreedplanHelp && entry.tipSheetUrl && (
            <Box sx={{ mt: 1.5 }}>
              <Link
                href={entry.tipSheetUrl}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ fontSize: '0.8125rem', fontWeight: 500 }}
              >
                View BREEDPLAN Tip Sheet
              </Link>
            </Box>
          )}
        </Box>
      )}
    </Popover>
  );
}
